module.exports = __webpack_public_path__ + "img/im.6cf57263.svg";